import mutations from './mutations'
import actions from './actions'

const state = {
  all_conservation_fees: [],
  conservation_fees: [],
  conservation_fee: [],
  deleted_conservation_fees: [],
  all_school_conservation_fees: [],
  all_full_conservation_fees: [],
  all_conservation_fees_schedule: [],
  residency_proof:[],
  residency_proof_booking_id:[],
  residency_proof_check_in:[],
  to_proof_residency:[],
  conservation_fees_proof:[],
  proofed_residency:[],
  conservation_fees_proof_checkin:[],
  all_bnl_schedules: []
 
}

export default {
  state, mutations, actions
}
